import ErrorFeedback from 'Components/ErrorFeedback/ErrorFeedback'
import ModalConfirmLeave from 'Components/ModalConfirmLeave'
import PageContainer from 'Components/PageContainer'
import useRouteLeaveGuard from 'Hooks/useRouteLeaveGuard/useRouteLeaveGuard'
import useWindowLeaveGuard from 'Hooks/useWindowLeaveGuard/useWindowLeaveGuard'
import Header from 'Pages/Workflow/components/Header'
import {
  changeWizardStepCallback,
  initPageCallback,
  resetPageCallback
} from 'Pages/Workflow/recoil/callbacks/callbacks'
import { modalActivateSimulateCloseCallback } from 'Pages/Workflow/recoil/callbacks/modalActivateSimulate'
import { activateCallback } from 'Pages/Workflow/recoil/callbacks/step5'
import { workflowDetails } from 'Pages/Workflow/recoil/state/data'
import { modalActivateSimulateState } from 'Pages/Workflow/recoil/state/modalActivateSimulate'
import { pageState } from 'Pages/Workflow/recoil/state/page'
import {
  Loading,
  SPACING_24,
  SpacingVertical,
  ToastContainer,
  Tooltip
} from 'mailup-web-components'
import { useCallback, useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import WizardContainer from './components/WizardContainer'

import ModalActivateSimulate from 'Components/ModalActivateSimulate'
import useDirtyGuard from './useDirtyGuard'

const Workflow = () => {
  const { idWorkflow } = useParams()
  const query = new URLSearchParams(useLocation().search)
  const ws = query.get('ws')
  const wt = query.get('wt')
  const { loading, isDirty, error, severity } = useRecoilValue(pageState)

  const wf = useRecoilValue(workflowDetails)

  const setPageState = useSetRecoilState(pageState)
  const init = useRecoilCallback(initPageCallback, [])

  const reset = useRecoilCallback(resetPageCallback, [])

  //  modalActivateSimulate
  const modalActivateSimulate = useRecoilValue(modalActivateSimulateState)
  const modalActivateSimulateClose = useRecoilCallback(
    modalActivateSimulateCloseCallback,
    []
  )
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])

  const handleEdit = useCallback(() => {
    modalActivateSimulateClose()
    changeWizardStep(2)
  }, [changeWizardStep, modalActivateSimulateClose])

  const handleActivate = useRecoilCallback(activateCallback, [])

  //

  /*
  useEffect(() => {
    !loaded && init(parseInt(idWorkflow), ws)
  }, [loaded])
  */

  useEffect(() => {
    // se idWorkflow è > 0 sono in edit altrimenti in new
    parseInt(idWorkflow) > 0 &&
      setPageState((prev) => ({ ...prev, edit: true }))
  }, [])

  useDirtyGuard()

  // Avviso l'utente se sta abbandonando la pagina con dati non salvati
  const [prompt, allow, deny] = useRouteLeaveGuard(!isDirty)
  useWindowLeaveGuard(!isDirty)

  useEffect(() => {
    init(parseInt(idWorkflow), ws, wt)

    return () => {
      reset()
    }
  }, [location.pathname])

  return (
    <>
      <Header />
      <Tooltip />
      <Loading open={loading} />
      <ToastContainer />
      <ModalConfirmLeave show={prompt} onConfirm={allow} onCancel={deny} />

      <ModalActivateSimulate
        show={modalActivateSimulate.show}
        mode={modalActivateSimulate.mode}
        recipientLimit={wf.RecipientLimit || 0}
        onClose={modalActivateSimulateClose}
        onEdit={handleEdit}
        onActivate={handleActivate}
        idWorkflow={wf.Id}
      />

      <PageContainer className='c-workflow'>
        {error && (
          <>
            <ErrorFeedback error={error} severity={severity} />
            <SpacingVertical variant={SPACING_24} />
          </>
        )}
        <WizardContainer />
      </PageContainer>
    </>
  )
}

export default Workflow
